import projectAgentSelectorComponent from './project-agent-selector.component';

const projectAgentSelectorModule = angular.module('projectAgentSelector', [
])
  .component('projectAgentSelector', projectAgentSelectorComponent)
  .name;

export default projectAgentSelectorModule;
